<template>
  <div class="m-pc-page">
    <div class="m-fixed-bg"></div>
    <Header></Header>
    <div class="m-pc-video" :class="{ full: screenStatus }">
      <Video></Video>
      <Lottery></Lottery>
    </div>
    <div class="m-pc-during">
      <TimeLine
        v-if="
          webinarInfo.replaySwitch !== 1 &&
            template.meeting.timeline &&
            template.meeting.timeline.display.value
        "
      ></TimeLine>
      <div
        class="m-during-area"
        v-html="adInfo.adContent"
        v-if="adInfo.adContent && template.meeting.ad.display.value"
      ></div>

      <div
        class="m-during-area"
        v-if="adImageInfo.length > 0 && template.meeting.adimage.display.value"
      >
        <Carousel></Carousel>
      </div>
      <Tab></Tab>

      <div class="m-during-area">
        <router-view></router-view>
      </div>
    </div>
    <div class="m-pc-minor">
      <div class="minor-wrap">
        <Ppt v-show="pptIsOpen" ref="ppt" :class="{ wide: screenStatus }"></Ppt>
        <Discuss
          v-if="webinarInfo.replaySwitch !== 1 && !ReplayliveState"
        ></Discuss>
        <Recommend
          v-if="
              webinarInfo.replaySwitch !== 1 &&
              template.meeting.recomannd &&
              template.meeting.recomannd.display.value &&
              !ReplayliveState
          "
        ></Recommend>
        <VideoLists
          v-if="webinarInfo.replaySwitch == 1 || ReplayliveState"
        ></VideoLists>
        <Recommend
            v-if="
              webinarInfo.replaySwitch === 1 &&
              template.meeting.recomannd &&
              template.meeting.recomannd.display.value &&
              !ReplayliveState
          "
        ></Recommend>
      </div>
    </div>
    <Suspension
      v-if="
        tenantPermInfo.isDisabledQuestionnaire == 2 ||
          tenantPermInfo.isDisabledLuckDraw == 2 ||
          tenantPermInfo.isDisabledDownloadFile == 2
      "
    ></Suspension>
  </div>
</template>

<script>
import $ from "jquery";
import { $subscriber, cr, ck } from "fire-wind-water";
import {
  joinMett,
  goToSignUp,
  onKickOut,
  validateState
} from "@/common/joinMeeting";
import { webinarId, tenantId, instanceId } from "../../common/sbase";
import URL from "../../assets/conf/setting.json";
import { socketModule } from "../../common/socket";
import webinarService from "../../services/webinar";
import Header from "@/components/pc/Header";
import Video from "@/components/pc/Video";
import TimeLine from "@/components/pc/TimeLine";
import Tab from "@/components/pc/Tab";
import Lottery from "@/components/pc/Lottery";
import Discuss from "@/components/pc/Discuss";
import Recommend from "@/components/pc/Recommend";
import VideoLists from "@/components/pc/VideoLists";
import Suspension from "@/components/pc/Suspension";
import Carousel from "@/components/pc/Carousel";
import { mixinsTemplate } from "../../common/mixinsTemplate";
import user from "../../common/user";
import Ppt from "@/components/pc/Ppt";
import comonService from "../../services/comonService";

export default {
  name: "Meeting",
  mixins: [mixinsTemplate],
  data() {
    return {
      webinarInfo: {},
      adInfo: {},
      adImageInfo: [],
      userInfo: {},
      player: {},
      screenStatus: false,
      pptIsOpen: false,
      schemaId: "",
      tenantId: "",
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
      isPlayBackStatus: false, //视频模块回放状态
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 ||
        window.location.href.indexOf("setting") > -1
          ? true
          : false //静态链接回放状态
    };
  },
  created() {
    window.$sk.template.module(this);
  },
  mounted() {
    this.tenantId = window.$sk.template.get().common.tenantId;
    this.schemaId = window.$sk.template.get().common.schemaId;
    this.init();
    window.addEventListener("beforeunload", e => this.beforeunloadFn(e));
  },
  methods: {

    init() {
      let _this = this;
      $subscriber.subscribe("webinarInfo.meeting", data => {
        this.webinarInfo = data;
        window.$sk.webinar.skUserEvent({
          type: "userCanJoin",
          data: this.webinarInfo
        });
        webinarService
          .getLiveLimit({
            tenantId: tenantId,
            webinarId: data.webinarId
          })
          .then(res => {
            if (!res.allowEnter) {
              window.location.href =
                "//s2-cdn.smarket.net.cn/public/limit/" +
                //   "//s2-cdn.smarket.net.cn/public/limit/" +
                "pc-information.html" +
                "?msg=" +
                encodeURIComponent(res.reminder) +
                "&returnUrl=" +
                encodeURIComponent(
                  window.location.href.replace("meeting", "meetingInfo")
                );
              return;
            }
          });
        //是否显示红包入口
        if (
          !this.webinarInfo.unLimit &&
          this.tenantPermInfo.isDisabledRedPacket == "2"
        ) {
          setTimeout(() => {
            window.$redEnvelope.init({
              type: "pc",
              tenantId: tenantId,
              instanceId: instanceId
            });
          }, 500);
        }
        let adList = data.adList;
        cr.each(adList, list => {
          if (list.adDevice != "wap") {
            if (list.adType == "2") {
              this.adInfo = list;
            } else {
              this.adImageInfo.push(list);
            }
          }
        });

        if (window.location.href.indexOf("isSetting") == -1) {
       //   if (data.replaySwitch !== 1) {
            this.getRecommend();
        //  }
          //直接改url进入 meeting页 判断 用户状态 （非setting时 ）↑
          setTimeout(() => {

          }, 2000);
        }
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
      });
      $subscriber.subscribe("onLoginMeeting", () => {
        if (!this.webinarInfo.unLimit) {
          if (this.webinarInfo.needLogin && !this.userInfo.isLogin) {
            //未登录
            window.$sk.loading.hide();
            $subscriber.emit("showPopup", {
              message: "很抱歉，登录成功才能进入本场会议。"
            });
            setTimeout(() => {
              joinMett(this.webinarInfo, this.userInfo);
            }, 1000);
          }
        }
      });
      $subscriber.subscribe("onSignUpMeeting", () => {
        if (!this.webinarInfo.unLimit) {
          if (this.webinarInfo.needLogin && !this.userInfo.isLogin) {
            return false;
          }
          if (!this.userInfo.isRegistration) {
            //未报名
            if (this.webinarInfo.needRegistration) {
              window.$sk.loading.hide();
              // 去常规报名
              $subscriber.emit("showPopup", {
                message: "很抱歉，报名成功才能进入本场会议。"
              });
              //延迟3秒跳转
              setTimeout(() => {
                goToSignUp(this.webinarInfo, jumpUrl => {
                  window.$sk.goto(jumpUrl);
                });
              }, 500);
            }
          }
        }
      });
      $subscriber.subscribe("change-line-stream", i => {
        window.$sk.webinar.skSdkEvent({
          type: "changeLineStream"
        });
      });
      $subscriber.subscribe("changeScreenStatus", () => {
        this.screenStatus = !this.screenStatus;
      });
      $subscriber.on("onKickout", data => {
        this.userInfo.hasPermission = false;
        onKickOut(data.reason);
      });
      $subscriber.on("kickOut", data => {
        onKickOut(data);
      });
      //只执行一次因为是单页面应用 如果是 on的话
      // 监听了两边（观看页一遍 踢出再进来又一遍） 也会执行两遍
      $subscriber.onic("onPublishGrabRedPacket", data => {
        if (data.length > 0) {
          data = data[0];
        }
        data.type = "pc";
        data.schemaId = this.schemaId;
        data.tenantId = this.tenantId;
        if (
          !this.webinarInfo.unLimit &&
          this.tenantPermInfo.isDisabledRedPacket == "2"
        ) {
          window.$redEnvelope.find({
            type: data.type,
            weChatId: data.weChatId,
            luckyDrawId: data.id,
            schemaId: data.schemaId,
            tenantId: data.tenantId,
            instanceId: data.instanceId,
            logoUrl: data.logoUrl,
            luckyName: data.luckyName, //红包名称
            rpBlessings: data.rpBlessings, //祝福语，
            rpBusinessName: data.rpBusinessName
          });
        }
      });
      $subscriber.subscribe("pptInfoChange", data => {
        this.pptIsOpen = data.pptIsOpen;
      });
      // this.pushHistory();
      // window.addEventListener("popstate", this.popstateReload, false);
      // $subscriber.onic("initSkSDK", res => {
      //   console.log('onic');
      //
      // });
      window.$sk.webinar.module({

        skMeetingLinkEnd() {
          const info = window.$sk.webinar.get().meetingInfo;
          const webianr = Object.assign(_this.webinarInfo, info);
          const userInfo = window.$sk.webinar.get().user;
          if (!validateState(webianr, userInfo)) {
            //状态不对  返回 meetingInfo
            if (window.location.href.indexOf("meetingInfo") == -1) {
              let returnUrl = window.location.href.replace(
                "/meeting",
                "/meetingInfo"
              );
              setTimeout(() => {
                window.location.href = returnUrl;
              }, 1000);
            }
          }
          _this.socketInit();
        },
        skPolyvNews(data) {
          if (data && data[0] && data[0].content.type == "switchMainScreen") {
            $subscriber.emit("switchMainScreen", data[0].content.data);
          } else if (data && data[0] && data[0].content.type == "taboo") {
            webinarService.gagTrue({
              uid: _this.userInfo.id,
              webinarId: webinarId,
              globalUserId: ck.cookie("globalUserId") || ""
            });
          } else if (
            data &&
            data[0] &&
            data[0].content.type == "recoveryTaboo"
          ) {
            webinarService.gagFalse({
              uid: _this.userInfo.id,
              webinarId: webinarId,
              globalUserId: ck.cookie("globalUserId") || ""
            });
          } else if (data && data[0] && data[0].content.type == "kickout") {
            webinarService.kickout({
              uid: _this.userInfo.id,
              webinarId: webinarId,
              tenantId: tenantId,
              globalUserId: ck.cookie("globalUserId") || ""
            });
          }
        }
      });
    },
    socketInit() {
      //若果是回看  不用出现临时用户弹窗
      if (this.webinarInfo.replaySwitch !== 1) {
        this.showUserNameDialog();
      }
      if (socketModule.isOn == null) {
        let userInfo = window.$sk.webinar.get().user;
        let webinarInfo = this.webinarInfo;
        $subscriber.emit("userInfo", userInfo);
        socketModule.init(URL.webinarbInteractUrl + "center", null);
        console.log("%c 开始链接socket", "color:#0f0;");
        socketModule.connect(userInfo, webinarInfo);
        console.log("%c 结束链接socket", "color:red;");
      }
      if (this.webinarInfo.replaySwitch !== 1) {
        window.$sk.webinar.skSdkEvent({
          type: "init",
          data: {
            webcastId: this.webinarInfo.webcastId,
            videoBg: this.template.meeting.videoBg.src.value,
            type: "live",
            webCastProvider: this.webinarInfo.webCastProvider,
            tenantId: this.webinarInfo.tenantId
          }
        });
      }
    },
    pushHistory() {
      var state = { title: "呵呵哒", url: "#" };
      window.history.pushState(state, "新页面标题#", window.location.href);
    },
    popstateReload() {
      window.location.reload();
    },
    validateWebinarState() {
      if (!this.webinarInfo.isReleased) {
        //会场未发布
        onKickOut("很抱歉，会场未发布");
      } else if (this.webinarInfo.isClosed) {
        // return
        if (this.webinarInfo.replaySwitch === 1) {
        } else {
          //会场已关闭
          if (this.webinarInfo.demandUrl) {
            // 已转点播
            // window.location.href = this.webinarInfo.demandUrl;
          } else {
            onKickOut("很抱歉，您来晚了，本场会议已经关闭");
          }
        }
      } else if (!this.webinarInfo.isOpen) {
        //会场未开放
        onKickOut("会场尚未开放，请您稍后再来");
      }
    },
    showUserNameDialog() {
      //无限制观看，未登录报名，未设置用户名
      if (
        this.webinarInfo.unLimit &&
        this.webinarInfo.isSetUserName &&
        this.userInfo.temporaryUserName == ""
      ) {
        if (
          !this.userInfo.isLogin &&
          (!this.userInfo.isRegistration ||
            (this.userInfo.isRegistration && this.userInfo.isUnLimit))
        ) {
          $subscriber.emit("showSetUserName", true);
        } else {
          $subscriber.emit("showSetUserName", false);
        }
      }
    },

    getRecommend() {
      webinarService
        .getRecommend({
          tenantId: this.webinarInfo.tenantId,
          webinarId: webinarId
        })
        .subscribe(data => {
          $subscriber.emit("recommendList", data ? data.content.items : []);
        });
    },
    beforeunloadFn(e) {
      socketModule.isOn = null;
      $subscriber.off("initSkSDK");
      console.log("%c 开始销毁socket", "color:#0f0;");
      socketModule.disconnect();
      console.log("%c 结束销毁socket", "color:red;");
      ///销毁目睹
      window.$sk.webinar.skSdkEvent({ type: "remove", data: {} });
      window.$redEnvelope.destroy();
      // window.removeEventListener("popstate", this.popstateReload);
    }
  },
  beforeDestroy() {
    socketModule.isOn = null;
    $subscriber.off("initSkSDK");
    console.log("%c 开始销毁socket", "color:#0f0;");
    socketModule.disconnect();
    console.log("%c 结束销毁socket", "color:red;");
    ///销毁目睹
    window.$sk.webinar.skSdkEvent({ type: "remove", data: {} });
    window.$redEnvelope.destroy();
  },
  components: {
    Header,
    Video,
    TimeLine,
    Tab,
    Lottery,
    Ppt,
    Discuss,
    Recommend,
    VideoLists,
    // Guests,
    Suspension,
    Carousel
  }
};
</script>

<style scoped></style>
